import Onboarding from './Onboarding';

export default Onboarding;
export * from './Onboarding';
